// Get My Counts Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import { QueryCountsEntity } from "../entities/QueryCountsEntity";
import { Result } from "../common/Result";

export class GetMyCountsUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(): Promise<Result<QueryCountsEntity>> {
    try {
      const counts = await this.repository.getMyCounts();
      return Result.ok(counts);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to fetch query counts");
    }
  }
}
